import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Fab,
    makeStyles
} from '@material-ui/core';
import {
    WhatsApp as WhatsAppIcon,
    PhoneRounded as TelefoneIcon
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    titulo: {
        marginBottom: 10
    },
    contato: {
        marginTop: 10
    },
    fab: {
        marginRight: 10
    }
}));

function CardServicoInexistente() {
    const classes = useStyles();

    return (
        <Card>
            <CardContent>
                <Typography variant="h5"
                    color='primary'
                    className={classes.titulo}>
                    Você ainda não tem serviços agendados!
                </Typography>
                <Typography variant="body2">
                    Em breve você poderá agendar os serviços por aqui! <span aria-hidden="true" role="img">👍</span>
                </Typography>
                <Typography variant="body2">
                    Enquanto isso, fale com a gente:
                </Typography>
                <Typography variant="body2"
                    className={classes.contato}>
                    <Fab className={classes.fab}
                        color='primary'
                        size='small'>
                        <WhatsAppIcon color='secondary' />
                    </Fab>
                    (31) 99910-1010
                </Typography>
                <Typography variant="body2"
                    className={classes.contato}>
                    <Fab className={classes.fab}
                        color='primary'
                        size='small'>
                        <TelefoneIcon color='secondary' />
                    </Fab>
                    0800 099 1001
                </Typography>
            </CardContent>
        </Card>
    );
}

export default CardServicoInexistente;